import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from 'components/common/MaterialIcon';
import {Input, Select, Checkbox} from 'antd';
import uuidv1 from 'uuid/v1';

@autobind
/**
 *
 */
export default class Header extends React.PureComponent {
  static propTypes = {
    dataTemplate: PropTypes.object,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    dataTemplate: {},
    disabled: false,
    onChange: () => {
    },
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {dataTemplate, onChange} = this.props;
    let style = {
      margin: 2,
    };

    return (
      <div
        style={{
          position: 'relative',
        }}
      >
        <Input
          type={'text'}
          onChange={(e) => {
            onChange({title: e.target.value})
          }}
          value={dataTemplate.title}/>
        <br/>
        <Checkbox
          style={style}
          checked={dataTemplate.showCompanyTitle}
          onChange={(e) => {
            onChange({showCompanyTitle: e.target.checked})
          }}
        >{app.translate('components.common.table.show company title', 'show company title')}</Checkbox>
        <br/>
        <Checkbox
          style={style}
          checked={dataTemplate.showCompanyLogo}
          onChange={(e) => {
            onChange({showCompanyLogo: e.target.checked})
          }}>{app.translate('components.common.table.show company logo', 'show company logo')}</Checkbox>
        <br/>
        <Checkbox
          style={style}
          checked={dataTemplate.showRowData}
          onChange={(e) => {
            onChange({showRowData: e.target.checked})
          }}>{app.translate('components.common.table.show row date', 'show row date')}</Checkbox>
        <br/>
        <Checkbox
          style={style}
          checked={dataTemplate.showFooterData}
          onChange={(e) => {
            onChange({showFooterData: e.target.checked})
          }}>{app.translate('components.common.table.show footer date', 'show footer date')}</Checkbox>
        <br/>
        <Checkbox
          style={style}
          checked={dataTemplate.margeTable}
          onChange={(e) => {
            onChange({margeTable: e.target.checked})
          }}>{app.translate('components.common.table.merge tables ', 'merge tables')}</Checkbox>
        <br/>
        <Checkbox
          style={style}
          checked={dataTemplate.signatory}
          onChange={(e) => {
            onChange({signatory: e.target.checked})
          }}>{app.translate('components.common.table.signatory ', 'Signatory')}</Checkbox>
        <br/>

        {
          this.props.disabled &&
          <div className='disabledBox'/>
        }
      </div>
    );
  }
}
